import React, { useEffect, useState } from 'react';
import AddressSearch from 'react-loqate';
import { Form } from "react-bootstrap"
import $ from "jquery/dist/jquery.min.js"


const AddressSearchInput = (props) => {

    function addresstype() {
        $("input[name=addressBuildingName]").val('');
    }


    return (
        <Form.Group className="text form-group">
            <div className="custom-float">
                <i className="icon-pin"></i>
                <input
                    name="address"
                    placeholder="Enter your address"
                    autocomplete="off"
                    type="text"
                    id="address"
                    className="form-control"
                    {...props}
                    value={props.addressLabel}
                    required="true"
                   // onKeyUp={addresstype()}
                />

                <input type="hidden" name="home_stno" id="home_stno" />
                <input type="hidden" name="home_street" id="home_street" />
                <input type="hidden" name="home_district" id="home_district" />
                <input type="hidden" name="home_post_town" id="home_post_town" />
                <input type="hidden" name="home_county" id="home_county" />
                <input type="hidden" name="home_postcode" id="home_postcode" />

            </div>
        </Form.Group>
    );
};

export default function Addresssearch(props) {
    const selectAddressval = (address) => {
        document.getElementById('address').value = (address.Label).replace(/\n/g, ", ")
        document.getElementById('home_stno').value = (address.BuildingNumber).replace(/\n/g, ", ")
        document.getElementById('home_street').value = (address.Street).replace(/\n/g, ", ")
        document.getElementById('home_district').value = (address.District).replace(/\n/g, ", ")
        document.getElementById('home_post_town').value = (address.City).replace(/\n/g, ", ")
        document.getElementById('home_county').value = (address.ProvinceName).replace(/\n/g, ", ")
        document.getElementById('home_postcode').value = address.PostalCode

        // document.getElementById('addressBuildingName').value = address.BuildingName
        // document.getElementById('addressBuildingNumber').value = address.BuildingNumber
        // document.getElementById('addressPostalCode').value = address.PostalCode
        // document.getElementById('addressSubBuilding').value = address.SubBuilding
        // document.getElementById('addressStreet').value = address.Street

        // sessionStorage.setItem('addressBuildingName', address.BuildingName)
        // sessionStorage.setItem('addressBuildingNumber', address.BuildingNumber)
        // sessionStorage.setItem('addressPostalCode', address.PostalCode)
        // sessionStorage.setItem('addressSubBuilding', address.SubBuilding)
        // sessionStorage.setItem('addressStreet', address.Street)
    }

    return (
        <AddressSearch
            locale="en_GB"
            apiKey={process.env.GATSBY_LOQATE_API_KEY}
            countries={['GB']}
            id="address"
            components={{ Input: AddressSearchInput }}
            inputClassname="address form-control address-search"
            listClassname="address-options"
            listItemClassname="address-option"
            onSelect={address => selectAddressval(address)}

        />
    )
}
